import React, { useState, useEffect } from 'react';
import { 
  SafeAreaView, 
  StyleSheet, 
  View, 
  Text, 
  FlatList, 
  Image, 
  TouchableOpacity, 
  ActivityIndicator, 
  TextInput, 
  ScrollView 
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { Linking } from 'react-native';

const App = ({ navigation }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [userData, setUserData] = useState({});

  const [sortOption, setSortOption] = useState(''); // Default no sorting


  const sortData = (data, option) => {
    if (!data || data.length === 0) return data;
    
    switch (option) {
        case 'a-z':
            return [...data].sort((a, b) => a.BrandName.localeCompare(b.BrandName));
        default:
            return data;
    }
};


const handleSendEmail = (venueEmail) => {
  if (!venueEmail) {
      alert("No email available for this venue.");
      return;
  }

  if (!userData.Username) {
      alert("You need to be logged in to send an email.");
      return;
  }

  // Generate Profile Link Based on the Logged-in User
  const profileLink = `https://collabbay.com/${userData.Username}`;
  
  const subject = encodeURIComponent("Collaboration Interest");
  const body = encodeURIComponent(`I'd love to visit.\n\nYou can see more about me here: ${profileLink}`);

  const mailtoLink = `mailto:${venueEmail}?subject=${subject}&body=${body}`;
  
  Linking.openURL(mailtoLink).catch(err => console.error("Error opening email", err));
};


  
  const [sortVisible, setSortVisible] = useState(false);


  useEffect(() => {
    if (searchQuery) {
        const filtered = data.filter(item =>
            item.BrandName.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredData(filtered);
    } else {
        setFilteredData(data);
    }
}, [searchQuery, data]);

  

  const fetchData = async () => {
    try {
      const response = await fetch('https://collabbay.com/APIControllers/GetVenueDirectory.php');
      const result = await response.json();
      setData(result);
      setFilteredData(result);
    } catch (error) {f
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserData = async () => {
    try {
      const response = await fetch('https://collabbay.com/APIControllers/GetSessionData.php');
      const result = await response.json();
      setUserData(result);
    } catch (error) {
      console.error('Error fetching user data: ', error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUserData();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      const filtered = data.filter(item =>
        item.BrandName.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [searchQuery, data]);

  const handleCardPress = (listingID) => {
    navigation.navigate('CreateSubmissionPage', { ListingID: listingID });
  };

  const handleLogout = async () => {
    try {
      const response = await fetch('https://collabbay.com/APIControllers/EndSession.php');
      await response.json();
      setUserData({});
      // Reload the app after logout
      window.location.reload();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleEditProfile = () => {
    window.open('https://collabbay.com/UpdateProfile.html');
  };

  const handlePersonIconPress = () => {
    if (userData.Username) {
      navigation.navigate('UserRecapPage');
    } else {
      navigation.navigate('LogInPage');
    }
  };

  const handleBackPress = () => {
    navigation.goBack();
  };




const renderItem = ({ item, index }) => (
    <View style={[styles.cardWrapper, index % 2 !== 0 && { marginLeft: 10 }]}>
        <TouchableOpacity
            style={styles.card}
            onPress={() => item.BrandURL && Linking.openURL(item.BrandURL)}
        >
            <Image source={{ uri: item.LogoImage }} style={styles.logoImage} />
            <View style={styles.cardContent}>
                <Text style={styles.brandName}>{item.BrandName}</Text>
                <View style={styles.locationContainer}>
                    <Ionicons name="location-outline" size={16} color="#000" />
                    <Text style={styles.locationText}>{item.Location}</Text>
                </View>

                {/* Email Button Inside the Card, Left-Aligned */}
                <TouchableOpacity 
                    style={styles.emailButton} 
                    onPress={() => handleSendEmail(item.VenueEmail)}
                >
                    <Ionicons name="mail-outline" size={20} color="black" />
                    <Text style={styles.emailButtonText}>Reach Out</Text>
                </TouchableOpacity>

            </View>
        </TouchableOpacity>
    </View>
);





  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
<SafeAreaView style={[styles.container, { width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 }]}>

  

      <ScrollView contentContainerStyle={styles.contentContainer}>

      <View>
  {/* Sort Icon to Toggle Dropdown */}
  <TouchableOpacity style={styles.sortIcon} onPress={() => setSortVisible(!sortVisible)}>
    <Ionicons name="filter-outline" size={24} color="black" />
  </TouchableOpacity>

  {/* Existing Sort Buttons, Hidden Until Clicked */}
  {sortVisible && (
    <View style={styles.sortContainer}>
      <TouchableOpacity style={styles.sortButton} onPress={() => { setSortOption('a-z'); setSortVisible(false); }}>
        <Text style={styles.sortText}>A-Z</Text>
      </TouchableOpacity>
    </View>
  )}
</View>


        <TouchableOpacity style={styles.backButton} onPress={handleBackPress}>
          <Ionicons name="arrow-back" size={28} color="black" />
        </TouchableOpacity>
        <TextInput
          style={styles.searchBar}
          placeholder="Search..."
          value={searchQuery}
          onChangeText={setSearchQuery}
          maxLength={500}
        />
      
      <ScrollView
  contentContainerStyle={{
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  }}
>
  <Text style={{ fontSize: 32, fontWeight: 'bold', color: 'black', textAlign: 'center' }}>
    Coming Soon...
  </Text>
</ScrollView>


      </ScrollView>
      <View style={styles.footer}>
        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('Homepage')}>
          <Ionicons name="home" size={24} color="black" />
        </TouchableOpacity>
        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('UserCollabDashboard')}>
          <Ionicons name="qr-code" size={24} color="black" />
        </TouchableOpacity>
        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('CollabCalendar')}>
          <Ionicons name="calendar" size={24} color="black" />
        </TouchableOpacity>


        
        <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('UserActivityFeed')}
  >
    <Ionicons name="chatbox-ellipses-outline" size={24} color="black" />
  </TouchableOpacity>

        {userData.Username ? (
          <TouchableOpacity style={styles.footerIcon} onPress={handlePersonIconPress}>
            <Ionicons name="person" size={24} color="black" />
          </TouchableOpacity>
        ) : (
          <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('LogInPage')}>
            <Ionicons name="person" size={24} color="black" />
          </TouchableOpacity>
        )}
      </View>
    </SafeAreaView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  contentContainer: {
    paddingHorizontal: 20,
    paddingTop: 70, // Added padding to account for the back button height
  },
  searchBar: {
    height: 40,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#ccc',
    paddingHorizontal: 15,
    marginVertical: 20,
    backgroundColor: '#f9f9f9',
    fontSize: 16,
  },
  list: {
    paddingBottom: 80, // Added padding for footer visibility
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 15,
    marginVertical: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 5,
  },
  logoImage: {
    width: '100%',
    height: 120,
    borderRadius: 10,
    marginBottom: 10,
    resizeMode: 'cover',
    backgroundColor: '#000',
  },
  cardContent: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  brandName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
  },
  customiseCTA: {
    fontSize: 24,
    marginTop: '40',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
    textalign: 'center',
  },
  customiseCTAsub: {
    fontSize: 15,
    marginTop: '10',
    color: '#b2b2b2',
    marginBottom: 5,
    textalign: 'center',
  },
  description: {
    fontSize: 16,
    color: '#000',
    marginBottom: 10,
  },
  creditsContainer: {
    backgroundColor: '#EEEDEB',
    borderRadius: 20,
    padding: 5,
    marginBottom: 10,
  },
  credits: {
    fontSize: 17,
    color: '#000',
    fontWeight: 'bold',
    padding: 5,
  },
  locationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  locationText: {
    fontSize: 14,
    color: '#000',
    marginLeft: 5,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    left: 0,
    right: 0,
    paddingVertical: 10,
  },
  footerIcon: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  backButton: {
    position: 'absolute',
    top: 20,
    left: 20,
    zIndex: 1,
  },
  sortContainer: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: 10,
  paddingHorizontal: 10,
},
sortButton: {
  backgroundColor: '#EEEDEB',
  padding: 10,
  borderRadius: 10,
  marginHorizontal: 5,
},
sortText: {
  fontSize: 14,
  fontWeight: 'bold',
  color: '#000',
},
sortIcon: {
  alignSelf: 'flex-end',
  padding: 10,
},

container: {
  flex: 1,
  backgroundColor: '#fff',
},
list: {
  paddingBottom: 80, // Added padding for footer visibility
  paddingHorizontal: 10,
},
cardWrapper: {
  flex: 1,
  marginBottom: 10,
},
card: {
  backgroundColor: '#fff',
  borderRadius: 10,
  padding: 10,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.1,
  shadowRadius: 10,
  elevation: 5,
},
logoImage: {
  width: '100%',
  height: 100,
  borderRadius: 10,
  marginBottom: 10,
  resizeMode: 'cover',
  backgroundColor: '#000',
},
cardContent: {
  flexDirection: 'column',
  alignItems: 'flex-start',
},
brandName: {
  fontSize: 16,
  fontWeight: 'bold',
  color: '#000',
  marginBottom: 5,
},
locationContainer: {
  flexDirection: 'row',
  alignItems: 'center',
},
locationText: {
  fontSize: 14,
  color: '#000',
  marginLeft: 5,
},
emailButton: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start', // Aligns button left
  backgroundColor: '#d6d6d6', // Blue button for contrast
  padding: 10,
  borderRadius: 8,
  marginTop: 10,
  width: '70%', // Keeps the button size small
},
emailButtonText: {
  color: 'black',
  fontSize: 14,
  fontWeight: 'bold',
  marginLeft: 5,
},


});

export default App;
